import React, { useEffect, useState } from "react";
import { Link } from "@quintype/components";
import { string, func } from "prop-types";

import { SvgIconHandler } from "../../../../../../atoms/svg-icon-hadler";
import { copyToClipboard } from "../utils";

import "./shareAllTemplate.m.css";

const ShareAllTemplate = ({ twitterUrl, fbUrl, mailtoUrl, linkedinUrl, whatsappUrl, fullUrl, setPopup }) => {
  const [showCopy, setShowCopy] = useState(false);

  useEffect(() => {
    if (showCopy) {
      const interval = setInterval(() => {
        setShowCopy(false);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [showCopy]);

  return (
    <div styleName="icon-wrapper" className="share-all-template">
      <div styleName="heading-wrapper">
        <span styleName="close-wrapper" onClick={() => setPopup(false)}>
          <SvgIconHandler type="close" width="24" height="24" viewBox="0 0 24 24" />
        </span>
        <span styleName="share-text">Share</span>
      </div>
      <div styleName="wrapper">
        <div styleName="first-column">
          <Link href={fbUrl} target="_blank" rel="noopener noreferrer" aria-label="facebook">
            <SvgIconHandler type="facebook" width="24" height="24" viewBox="0 0 24 24" />{" "}
            <span styleName="share-title">Share on Facebook</span>
          </Link>
          <Link href={mailtoUrl} target="_blank" rel="noopener noreferrer" aria-label="email">
            <SvgIconHandler type="mail" width="24" height="24" viewBox="0 0 24 24" />{" "}
            <span styleName="share-title">Email</span>
          </Link>
          <div styleName="share-icon">
            <label htmlFor="input-url">
              <input type="hidden" id="input-url" value="Copied!"></input>
            </label>
            <span onClick={() => copyToClipboard(fullUrl, setShowCopy)} styleName="copy-link">
              <SvgIconHandler type="copy" width="24" height="24" viewBox="0 0 24 24" />{" "}
              <span styleName="share-title">Copy link</span>
              {showCopy && <span styleName="copy-popup">Link Copied</span>}
            </span>
          </div>
        </div>
        <div styleName="second-column">
          <Link
            href={linkedinUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="linkedin"
            aria-label="share on linkedin"
          >
            <SvgIconHandler type="linkedin" width="24" height="24" viewBox="0 0 24 24" />{" "}
            <span styleName="share-title">Share on LinkedIn</span>
          </Link>
          <Link href={twitterUrl} target="_blank" rel="noopener noreferrer" aria-label="share on twitter">
            <SvgIconHandler type="twitter" width="24" height="24" viewBox="0 0 24 24" />{" "}
            <span styleName="share-title">Share on Twitter</span>
          </Link>
          <Link
            className="whatsapp-wrapper"
            href={whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            aria-label="share on whatsapp"
          >
            <SvgIconHandler type="whatsapp" width="24" height="24" viewBox="0 0 24 24" />
            <span styleName="share-title">Share on Whatsapp</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

ShareAllTemplate.propTypes = {
  twitterUrl: string,
  fbUrl: string,
  mailtoUrl: string,
  linkedinUrl: string,
  whatsappUrl: string,
  fullUrl: string,
  setPopup: func,
};

export default ShareAllTemplate;
